module.exports = __webpack_public_path__ + "img/asdbase.25ef6459.png";